import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0b9dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__generic-accordion" }

import { computed, ref, toRefs, watch } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'generic-accordion',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:model-value"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  const { value } = toRefs(props);
  const internalState = ref<boolean>(false);

  const showContent = computed(() => {
      // we use xor here, so when one of the two variables flips,
      // the output flips
      return !!internalState.value;
    })
  const chevronClass = computed(() => showContent.value ? "fi-expand_less" : "fi-expand_more")
  
  const toggle = () => {
    emit("update:model-value", !internalState.value);
    internalState.value = !internalState.value;
  };

  watch(value, (newValue: boolean) => {
    internalState.value = newValue;
  }, 
  { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "accordion-header-container",
      onClick: toggle
    }, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createTextVNode("HEADER")
        ])
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "chevron", {}, () => [
          _createElementVNode("i", {
            class: _normalizeClass(["accordion-chevron frontend-icon", chevronClass.value])
          }, null, 2)
        ])
      ])
    ]),
    (showContent.value)
      ? _renderSlot(_ctx.$slots, "content", { key: 0 }, () => [
          _createTextVNode("CONTENT")
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})